export type SearchableProductRow = {
  product_name: string;
  product_short_name?: string | null;
  product_sku?: string | null;
};

// Matches the grid's product label (short name), the full name, and the SKU.
export function matchesProductSearch(row: SearchableProductRow, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [row.product_short_name, row.product_name, row.product_sku].some(
    (field) => (field ?? "").toLowerCase().includes(q),
  );
}
